<template>
  <div id="cakeNotify"></div>
</template>
<script>
export default {
  name: 'CakeNotify',
  async mounted() {
    const cakeSession = this.$store.state.auth.cakeSession
    if (cakeSession) {
      this.getCakeNotify(cakeSession)
    }
  },
  methods: {
    async getCakeNotify(cakeSession) {
      try {
        const cakeNotify = await this.$store.dispatch('cakeNotify/getCakeNotify', cakeSession)
        if (cakeNotify && cakeNotify.message) {
          this.$notify({
            group: 'flash',
            title: cakeNotify.message,
            type: cakeNotify.level
          })
        }
      } catch (err) {
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#cakeNotify {
  display: none;
}
</style>
